import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

let UiCConfirmationPixComponent = class UiCConfirmationPixComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConfirmationPixComponent.prototype, "phone", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConfirmationPixComponent.prototype, "CPF", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConfirmationPixComponent.prototype, "CNPJ", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConfirmationPixComponent.prototype, "EMAIL", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConfirmationPixComponent.prototype, "account", void 0);
UiCConfirmationPixComponent = __decorate([
    Component({
        selector: 'ui-c-confirmation-pix',
        template: "  <div>\n    <h3 class=\"font-family-bold\">\n      {{'PIX.CONFIRMATION_PIX.HEADER.SUBTITLE' | wlpTranslate}}\n    </h3>\n  </div>\n  <ion-text class=\"ion-text-start\" *ngIf=\"phone\">\n    <p class=\" margin-bottom-and-top-15\">\n      {{'PIX.CONFIRMATION_PIX.CONFIRMATION_TEXT.PHONE' | wlpTranslate}}</p>\n    <p class=\"font-family-bold  margin-bottom-and-top-15\">\n      {{phone}}</p>\n  </ion-text>\n  <ion-text class=\"ion-text-start\" *ngIf=\"CPF\">\n    <p class=\"margin-bottom-and-top-15\">\n      {{'PIX.CONFIRMATION_PIX.CONFIRMATION_TEXT.CPF' | wlpTranslate}}</p>\n    <p class=\"font-family-bold  margin-bottom-and-top-15\">\n      {{CPF}}</p>\n  </ion-text>\n  <ion-text class=\"ion-text-start\" *ngIf=\"CNPJ\">\n    <p class=\"margin-bottom-and-top-15\">\n      {{'PIX.CONFIRMATION_PIX.CONFIRMATION_TEXT.CNPJ' | wlpTranslate}}</p>\n    <p class=\"font-family-bold  margin-bottom-and-top-15\">\n      {{CNPJ}}</p>\n  </ion-text>\n  <ion-text class=\"ion-text-start\" *ngIf=\"EMAIL\">\n    <p class=\" margin-bottom-and-top-15\">\n      {{'PIX.CONFIRMATION_PIX.CONFIRMATION_TEXT.EMAIL' | wlpTranslate}}</p>\n    <p class=\"font-family-bold  margin-bottom-and-top-15\">\n      {{EMAIL}}</p>\n  </ion-text>\n  <ion-text class=\"ion-text-start\">\n    <p class=\" margin-bottom-and-top-15\">\n      {{'PIX.CONFIRMATION_PIX.CONFIRMATION_TEXT.TYPE_ACCOUNT' | wlpTranslate}}</p>\n    <p class=\"font-family-bold  margin-bottom-and-top-15\">\n      {{account}}</p>\n  </ion-text>\n  \n  <!--   \n  <div class=\"d-flex align-items-center visualization-check\">\n    <ion-checkbox mode=\"ios\"></ion-checkbox>\n    <ion-text>{{'PIX.CONFIRMATION_NOTIFICATION_MODAL.VISUALIZATION_MESSAGE' | wlpTranslate}}</ion-text>\n  </div> -->\n \n\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCConfirmationPixComponent);

let UiCConfirmationPixModule = class UiCConfirmationPixModule {
};
UiCConfirmationPixModule = __decorate([
    NgModule({
        declarations: [UiCConfirmationPixComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCConfirmationPixComponent]
    })
], UiCConfirmationPixModule);

export { UiCConfirmationPixComponent, UiCConfirmationPixModule };
//# sourceMappingURL=wlp-ui-c-confirmation-pix.js.map
